import React from "react";

const CustomCheckbox = ({ checked, onClick, label, id }) => {
  console.log("CustomCheckbox rendered, checked:", checked);

  return (
    <div className="flex items-center">
      <div
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        className={`w-6 h-6 mr-3 rounded-md border-2 flex items-center justify-center cursor-pointer
          transition-all duration-300 ease-in-out transform hover:scale-105 focus:outline-none
          focus:ring-2 focus:ring-green-300 focus:ring-opacity-50
          ${checked ? "bg-green-500 border-green-500" : "bg-white border-gray-300 hover:bg-gray-50"}`}
        role="checkbox"
        aria-checked={checked}
        aria-labelledby={label ? `label-${id}` : undefined}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        }}
      >
        {checked && (
          <svg
            className="w-4 h-4 text-white transform scale-0 transition-transform duration-200 ease-out"
            style={{
              animation: checked ? "scaleIn 0.2s ease-out forwards" : "none",
            }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="3"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </div>
      {label && (
        <label
          id={`label-${id}`}
          className="text-gray-700 text-sm cursor-pointer select-none"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          {label}
        </label>
      )}
    </div>
  );
};

// Add CSS animation for the checkmark
const styles = `
  @keyframes scaleIn {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default CustomCheckbox;
